'use client'

import { Button } from '../button'
import { Flex } from '../flex'

type ErrorProps = {
  errorCode: number
  messageLine1?: string
  messageLine2?: string
  returnToHomeButtonText: string
  onReturnHome: () => void
}

function Error({
  errorCode,
  messageLine1 = '所属会社のシステム管理者へ問い合わせてください',
  messageLine2 = 'Please contact the system administrator of your company',
  returnToHomeButtonText,
  onReturnHome,
}: ErrorProps) {
  return (
    <Flex
      align="center"
      className="min-h-screen bg-white text-input-label"
      direction="column"
      gap="8"
      justify="center"
    >
      <h2 className="text-8xl">{errorCode}</h2>
      <p className="text-center text-4xl leading-12">
        {messageLine1}
        <br />
        {messageLine2}
      </p>
      <Button onClick={onReturnHome}>{returnToHomeButtonText}</Button>
    </Flex>
  )
}

export default Error
